module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', [_c('CellTips', [_vm._v("说明的列表项")]), _vm._v(" "), _c('Cell', [_c('ListItem', {
    attrs: {
      "title": "无说明"
    }
  }), _vm._v(" "), _c('ListItem', {
    attrs: {
      "title": "有说明",
      "desc": "说明文字"
    }
  }), _vm._v(" "), _c('ListItem', {
    attrs: {
      "title": "可滑动",
      "desc": "往左滑试试"
    }
  }, [_c('button', [_vm._v("Set to top")]), _vm._v(" "), _c('button', [_vm._v("Delete")])])]), _vm._v(" "), _c('CellTips', [_vm._v("链接的列表项")]), _vm._v(" "), _c('Cell', [_c('ListItem', {
    attrs: {
      "title": "带图片",
      "link": "list",
      "img": "https://imgly.net/img/2gj.jpg"
    }
  }), _vm._v(" "), _c('ListItem', {
    attrs: {
      "title": "带图标",
      "link": "list",
      "icon": "fa fa-comment"
    }
  }), _vm._v(" "), _c('ListItem', {
    attrs: {
      "title": "不带图标",
      "link": "list",
      "desc": "说明文字"
    }
  }), _vm._v(" "), _c('ListItem', {
    attrs: {
      "title": "可滑动",
      "link": "list",
      "desc": "往左滑试试"
    }
  }, [_c('button', [_vm._v("Set to top")]), _vm._v(" "), _c('button', [_vm._v("Delete")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-64e752bf!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/listView.vue
// module id = 253
// module chunks = 0